import axios from "axios"

export const LoginAction = (username, password) => async (dispatch) => {
    try {
        dispatch({
            type: 'USER_LOGIN_REQUEST'
        })
        const config = {
            headers: {
                'Content-Type': 'application/json'
            }
        }
        const { data } = await axios.post(
            `${process.env.REACT_APP_DP_API}/api/dealer-portal/login`,
            { username, password },
            config
        )
        dispatch({
            type: 'USER_LOGIN_SUCCESS',
            payload: data
        })
        localStorage.setItem('dealerInfo', JSON.stringify(data))
    } catch (error) {
        dispatch({
            type: 'USER_LOGIN_FAIL',
            payload: error.response && error.response.data.message ?
                error.response.data.message : error.message
        })
    }
}

export const logout = () => (dispatch) => {
    localStorage.removeItem('dealerInfo')
    dispatch({ type: 'USER_LOGOUT' })
    document.location.href = '/login'
}

